export default "__VITE_ASSET__C_e2yASn__"